import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavMenu } from '../nav-menu/nav-menu';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.html',
  styleUrls: ['./contact.css'],
  imports: [NavMenu],
})
export class Contact implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
